var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.GenericKeyCopyModal,{attrs:{"title":"DataPlatform","loading":_setup.loading,"value":_setup.connectionString},on:{"close":function($event){return _setup.emit('close')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }